// Set to true only by product-form.js onSubmitHandler; prevents Rebuy /cart/add from opening drawer
window.userInitiatedCartAdd = false;

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    // Flag to track if we're closing via rebuy close button
    this.closingViaRebuyClose = false;
    
    // Flag to track if smart cart is loaded
    this.smartCartLoaded = false;

    // Removed Escape key and overlay click handlers - only rebuy close button will close drawer
    // this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    // this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.toggleCategoryReminder();
    this.handleRebuyCartClose();
    this.handleRebuyCartOpen();
    this.preventActiveClassRemoval();
    this.interceptAddToCart();
  }

  toggleCategoryReminder(){
    $('body').on('click', '[category-reminder-toggler]', function(){
      $('.cart-drawer_category-reminder').toggleClass('open');
    })
  }

  handleRebuyCartClose(){
    const closeDrawer = (drawer) => {
      if (drawer) {
        // Set flag to allow closing
        drawer.closingViaRebuyClose = true;
        drawer.classList.remove('active');
        drawer.style.display = 'none';
        document.body.classList.remove('overflow-hidden');
        // Reset flag after a short delay
        setTimeout(() => {
          drawer.closingViaRebuyClose = false;
        }, 100);
      }
    };

    document.addEventListener('click', (event) => {
      const drawer = document.querySelector('.mrMiniCart-drawer');

      // Close drawer when clicking rebuy close button
      if (event.target.closest('#rebuy-cart-close')) {
        closeDrawer(drawer);
      }

      // Close drawer when clicking rebuy product title
      if (event.target.closest('.rebuy-cart__flyout-item-product-title')) {
        closeDrawer(drawer);
      }

      // Close drawer when clicking the overlay backdrop (theme or Rebuy)
      if (event.target.closest('#CartDrawer-Overlay') || event.target.closest('.rebuy-cart__background')) {
        closeDrawer(drawer);
      }
    });
  }

  handleRebuyCartOpen(){
    const drawer = this;

    // Listen for rebuy smartcart ready event
    document.addEventListener('rebuy:smartcart.ready', (event) => {
      drawer.smartCartLoaded = true;
    });

    // Check if smart cart is already loaded (in case event already fired)
    if (document.querySelector('.rebuy-cart__flyout') || document.querySelector('#rebuy-cart')) {
      this.smartCartLoaded = true;
    }

    this.watchRebuyCartForCountChanges();
  }

  watchRebuyCartForCountChanges() {
    let debounceTimer = null;

    const syncBubbleCount = () => {
      fetch('/cart.js')
        .then((r) => r.json())
        .then((cart) => {
          const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
          if (!bubble) return;
          const visibleCount = bubble.querySelector('span[aria-hidden="true"]');
          const hiddenCount = bubble.querySelector('.visually-hidden');
          if (visibleCount) visibleCount.textContent = cart.item_count < 100 ? cart.item_count : '';
          if (hiddenCount) hiddenCount.textContent = cart.item_count;
          bubble.style.display = cart.item_count === 0 ? 'none' : '';
        })
        .catch(() => {});
    };

    const attachObserver = (flyout) => {
      const observer = new MutationObserver(() => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(syncBubbleCount, 150);
      });
      observer.observe(flyout, { childList: true, subtree: true });
    };

    // Attach immediately if flyout already exists, otherwise wait for it
    const existingFlyout = document.querySelector('.rebuy-cart__flyout, #rebuy-cart');
    if (existingFlyout) {
      attachObserver(existingFlyout);
    } else {
      const waitForFlyout = new MutationObserver(() => {
        const flyout = document.querySelector('.rebuy-cart__flyout, #rebuy-cart');
        if (flyout) {
          waitForFlyout.disconnect();
          attachObserver(flyout);
        }
      });
      waitForFlyout.observe(document.body, { childList: true, subtree: true });
    }
  }

  interceptAddToCart(){
    // Intercept all fetch requests to /cart/add to reset the userInitiatedCartAdd flag
    const originalFetch = window.fetch;

    window.fetch = function(...args) {
      const [url] = args;
      const isAddToCart = typeof url === 'string' && url.includes('/cart/add');
      
      return originalFetch.apply(this, args).then(response => {
        if (isAddToCart) {
          window.userInitiatedCartAdd = false;
        }
        return response;
      });
    };
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      if (!event.isTrusted) return;
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (!this.smartCartLoaded) return;
    
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    
    // Reset display property if it was set to none by rebuy close button
    if (this.style.display === 'none') {
      this.style.display = '';
    }
    
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    // No-op: Rebuy calls close() internally on every interaction inside the cart.
    // Actual closing is handled exclusively by handleRebuyCartClose() → closeDrawer().
  }

  preventActiveClassRemoval() {
    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.attributeName !== 'class') continue;
        const hadActive = mutation.oldValue ? mutation.oldValue.split(' ').includes('active') : false;
        if (hadActive && !this.classList.contains('active') && !this.closingViaRebuyClose) {
          this.classList.add('active');
        }
      }
    }).observe(this, { attributes: true, attributeFilter: ['class'], attributeOldValue: true });
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      const sectionHTML = parsedState.sections && parsedState.sections[section.id];
      if (sectionElement && sectionHTML) {
        sectionElement.innerHTML = this.getSectionInnerHTML(sectionHTML, section.selector);
      }
    }));

    setTimeout(() => {
      // Removed overlay click handler - only rebuy close button will close drawer
      // this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      // this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// Rebuy & Okendo integration
function injectOkendoStarsInRebuyWidgets() {
  const productBlocks = document.querySelectorAll('.rebuy-product-block');
  let injectedAny = false;

  productBlocks.forEach(block => {
    // 1. Check if Okendo widget is already injected
    if (block.querySelector('[data-oke-star-rating]')) {
      return;
    }

    // 2. Find the product ID from class list (e.g. product-id-10162133532963)
    let productId = null;
    block.classList.forEach(cls => {
      if (cls.startsWith('product-id-')) {
        productId = cls.replace('product-id-', '');
      }
    });

    if (!productId) return;

    // 3. Find the container to insert into (e.g. inside .rebuy-product-info)
    const productInfo = block.querySelector('.rebuy-product-info');
    if (!productInfo) return;

    const productTitle = productInfo.querySelector('.rebuy-product-title');
    if (!productTitle) return;

    // 4. Create the Okendo star rating element
    const ratingDiv = document.createElement('div');
    ratingDiv.className = 'okeReviews oke-sr-stars-only';
    ratingDiv.setAttribute('data-oke-star-rating', '');
    ratingDiv.setAttribute('data-oke-reviews-product-id', `shopify-${productId}`);
    ratingDiv.setAttribute('data-oke-scroll-disabled', 'true');

    // Insert after the title
    productTitle.after(ratingDiv);
    injectedAny = true;
  });

  // 5. If we injected any new widgets, initialize them via Okendo API
  if (injectedAny && window.okeWidgetApi && typeof window.okeWidgetApi.initAllWidgets === 'function') {
    window.okeWidgetApi.initAllWidgets();
  }
}

function isOutsideCartProgressMount(el) {
  return el && !el.closest('[data-rebuy-progress-mount]');
}

function setCartProgressFooterState(footer, hasProgress) {
  if (!footer) return;
  footer.classList.toggle('has-rebuy-progress', hasProgress);
}

function getCartProgressSubtotal(overrideCents) {
  if (typeof overrideCents === 'number' && !Number.isNaN(overrideCents)) {
    return overrideCents / 100;
  }
  const subtotalEl = document.querySelector('[data-subtotal]');
  if (!subtotalEl) return 0;
  return parseInt(subtotalEl.getAttribute('data-subtotal'), 10) / 100;
}

function getProgressFillPercent(dollars, tiers) {
  const count = tiers.length;
  let completed = 0;
  for (let i = 0; i < count; i += 1) {
    const min = Number(tiers[i].minimum);
    const prev = i === 0 ? 0 : Number(tiers[i - 1].minimum);
    if (dollars >= min) {
      completed += 1;
      if (i === count - 1) return 100;
    } else {
      const span = min - prev;
      const part = span > 0 ? Math.min(Math.max(dollars - prev, 0) / span, 1) : 0;
      return ((completed + part) / count) * 100;
    }
  }
  return 0;
}

function getProgressPromptLabel(dollars, tiers) {
  const nextTier = tiers.find((tier) => dollars < Number(tier.minimum));
  const lastTier = tiers[tiers.length - 1];
  if (!nextTier) {
    return (
      lastTier.decorative_amount_reached_label_text ||
      lastTier.discount_amount_reached_label_text ||
      lastTier.product_amount_reached_label_text ||
      ''
    );
  }
  const remaining = Math.max(Number(nextTier.minimum) - dollars, 0);
  const remainingText = remaining.toLocaleString('en-NZ', {
    style: 'currency',
    currency: 'NZD',
  });
  const template =
    nextTier.decorative_amount_remaining_label_text ||
    nextTier.discount_amount_remaining_label_text ||
    nextTier.product_amount_remaining_label_text ||
    'You are {{remaining_amount}} away';
  return template.replace(/\{\{\s*remaining_amount\s*\}\}/g, remainingText);
}

function getLiveProgressStepIcon(index) {
  const icons = Array.from(
    document.querySelectorAll(
      '#rebuy-cart .rebuy-cart__progress-step-icon, .rebuy-cart__flyout .rebuy-cart__progress-step-icon'
    )
  ).filter(isOutsideCartProgressMount);
  return icons[index] ? icons[index].innerHTML : '';
}

function buildProgressReplica(bar, dollars) {
  const tiers = bar.tiers;
  const replica = document.createElement('div');
  replica.setAttribute('data-rebuy-component', 'progress-bar');
  replica.setAttribute('data-rebuy-progress-replica', '');

  const steps = document.createElement('div');
  steps.className = `rebuy-cart__progress-step-wrapper count-${tiers.length}`;
  const stepWidth = `${100 / tiers.length}%`;

  tiers.forEach((tier, index) => {
    const step = document.createElement('div');
    step.className = 'rebuy-cart__progress-step';
    if (dollars >= Number(tier.minimum)) step.classList.add('complete');
    step.style.width = stepWidth;

    const icon = document.createElement('div');
    icon.className = 'rebuy-cart__progress-step-icon';
    const liveIcon = getLiveProgressStepIcon(index);
    icon.innerHTML =
      liveIcon ||
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="1.6" d="M6 8h12l-1 12H7L6 8z"/><path fill="none" stroke="currentColor" stroke-width="1.6" d="M9 8V7a3 3 0 0 1 6 0v1"/><path fill="none" stroke="currentColor" stroke-width="1.6" d="M12 12v4M10 14h4"/></svg>';

    const label = document.createElement('span');
    label.className = 'rebuy-cart__progress-step-label';
    label.textContent = tier.custom_tier_label_text || `$${tier.minimum}`;

    step.append(icon, label);
    steps.append(step);
  });

  const wrapper = document.createElement('div');
  wrapper.className = 'rebuy-cart__progress-bar-wrapper';

  const meter = document.createElement('div');
  meter.className = 'rebuy-cart__progress-bar-meter has-progress';
  const fill = document.createElement('div');
  fill.className = 'rebuy-cart__progress-bar-meter-fill';
  fill.style.width = `${getProgressFillPercent(dollars, tiers)}%`;
  meter.append(fill);

  const prompt = document.createElement('div');
  prompt.className = 'rebuy-cart__progress-bar-prompt';
  prompt.innerHTML = getProgressPromptLabel(dollars, tiers);

  wrapper.append(meter, prompt);
  replica.append(steps, wrapper);
  return replica;
}

let cachedProgressBar = null;

function withProgressBar(callback) {
  if (cachedProgressBar) {
    callback(cachedProgressBar);
    return;
  }
  const configPromise = window.__rebuyConfigFetch;
  if (!configPromise || typeof configPromise.then !== 'function') return;
  configPromise.then((payload) => {
    const smartCart = payload && payload.data && payload.data.smart_cart;
    const tpb = ((smartCart && smartCart.components) || []).find(
      (component) => component.type === 'tiered_progress_bar' && component.visibility_status !== 'hidden'
    );
    const bar = tpb && tpb.settings && tpb.settings.bars && tpb.settings.bars[0];
    if (!bar || !Array.isArray(bar.tiers) || !bar.tiers.length) return;
    cachedProgressBar = bar;
    callback(bar);
  });
}

function updateProgressReplica(mount, bar, dollars) {
  const existing = mount.querySelector('[data-rebuy-progress-replica]');
  const fillWidth = `${getProgressFillPercent(dollars, bar.tiers)}%`;
  const promptHtml = getProgressPromptLabel(dollars, bar.tiers);

  if (!existing) {
    const replica = buildProgressReplica(bar, dollars);
    if (!replica.querySelector('.rebuy-cart__progress-bar-prompt').innerHTML) return;
    mount.replaceChildren(replica);
    return;
  }

  const fill = existing.querySelector('.rebuy-cart__progress-bar-meter-fill');
  if (fill && fill.style.width !== fillWidth) fill.style.width = fillWidth;

  const prompt = existing.querySelector('.rebuy-cart__progress-bar-prompt');
  if (prompt && prompt.innerHTML !== promptHtml) prompt.innerHTML = promptHtml;

  existing.querySelectorAll('.rebuy-cart__progress-step').forEach((step, index) => {
    const tier = bar.tiers[index];
    if (!tier) return;
    step.classList.toggle('complete', dollars >= Number(tier.minimum));
  });
}

function renderRebuyProgressFallback(mount, footer, overrideCents) {
  withProgressBar((bar) => {
    updateProgressReplica(mount, bar, getCartProgressSubtotal(overrideCents));
    setCartProgressFooterState(footer, true);
  });
}

function syncRebuyProgressToCartPage(overrideCents) {
  if (overrideCents && typeof overrideCents === 'object') overrideCents = undefined;
  const mount = document.querySelector('[data-rebuy-progress-mount]');
  if (!mount) return;

  const footer = mount.closest('.cart__footer');
  const cartIsEmpty = Boolean(document.querySelector('#main-cart-footer.is-empty'));

  if (cartIsEmpty) {
    mount.replaceChildren();
    setCartProgressFooterState(footer, false);
    return;
  }

  renderRebuyProgressFallback(mount, footer, overrideCents);
}

function startRebuyProgressSync() {
  syncRebuyProgressToCartPage();
  let attempts = 0;
  const timer = setInterval(() => {
    attempts += 1;
    syncRebuyProgressToCartPage();
    if (
      document.querySelector('[data-rebuy-progress-mount] .rebuy-cart__progress-step-wrapper') ||
      attempts >= 40
    ) {
      clearInterval(timer);
    }
  }, 250);
}

document.addEventListener('rebuy:widget.ready', injectOkendoStarsInRebuyWidgets);
document.addEventListener('rebuy:widget.change', injectOkendoStarsInRebuyWidgets);
document.addEventListener('rebuy:widget.update', injectOkendoStarsInRebuyWidgets);
document.addEventListener('rebuy:smartcart.ready', injectOkendoStarsInRebuyWidgets);
document.addEventListener('rebuy:smartcart.ready', syncRebuyProgressToCartPage);
document.addEventListener('rebuy:smartcart.change', syncRebuyProgressToCartPage);
document.addEventListener('rebuy:smartcart.update', syncRebuyProgressToCartPage);
document.addEventListener('rebuy:cart.change', syncRebuyProgressToCartPage);

if (window.jQuery) {
  window.jQuery(window).on('cart:quantity-update', (_event, state) => {
    const total = state && typeof state.total_price === 'number' ? state.total_price : undefined;
    syncRebuyProgressToCartPage(total);
  });
}

document.addEventListener('cart:updated', (event) => {
  const total = event.detail && typeof event.detail.total_price === 'number' ? event.detail.total_price : undefined;
  syncRebuyProgressToCartPage(total);
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startRebuyProgressSync);
} else {
  startRebuyProgressSync();
}

// Fallback observer to ensure they get loaded even if events fire early or rendering is slow
const rebuyObserver = new MutationObserver((mutations) => {
  let shouldCheck = false;
  for (let mutation of mutations) {
    if (
      (mutation.target && mutation.target.closest && mutation.target.closest('[data-rebuy-progress-mount]')) ||
      (mutation.target && mutation.target.classList && mutation.target.classList.contains('rebuy-cart__progress-bar-prompt') && mutation.target.closest('[data-rebuy-progress-mount]'))
    ) {
      continue;
    }
    if (
      mutation.target &&
      mutation.target.classList &&
      mutation.target.classList.contains('rebuy-product-block')
    ) {
      shouldCheck = true;
      break;
    }
    if (mutation.addedNodes.length > 0) {
      for (let node of mutation.addedNodes) {
        if (
          node.nodeType === 1 &&
          !node.closest('[data-rebuy-progress-mount]') &&
          (node.classList.contains('rebuy-product-block') ||
            node.querySelector('.rebuy-product-block'))
        ) {
          shouldCheck = true;
          break;
        }
      }
    }
    if (shouldCheck) break;
  }
  if (shouldCheck) {
    injectOkendoStarsInRebuyWidgets();
  }
});

// Start observing document body for changes in rebuy product blocks
rebuyObserver.observe(document.body, {
  childList: true,
  subtree: true
});
